import { render } from "./EditProfileForm.vue?vue&type=template&id=61ca1f81&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"

import "./EditProfileForm.vue?vue&type=style&index=0&id=61ca1f81&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ca1f81"]])

export default __exports__